import React from 'react';
import { RiCloseCircleLine } from "react-icons/ri";

const getDefaultName = (tabType, index) => {
    return tabType === "client" ? `Plaintiff ${index}` : `Defendant ${index}`
}

const Tabs = ({ tabList = [], selectedTabIndex = 0, onTabChange, onDeleteTab = null, addNewTab = null, tabType, formSteps=0,isModalTab=false }) => {
    return (
        <>
            <div className={`d-flex align-items-center flex-wrap ${formSteps === 0 ? 'tab-b-pd' : 'multi-pd' 
                                }`}>
                {tabList.map((elem, index) => {
                    const isActive = index === selectedTabIndex;
                    return (
                        <button
                            key={index}
                            type="button"
                            className={`px-4 py-2 me-2 border-0 ${isActive ? 'fw-bold text-dark' : 'text-secondary'
                                }`}
                            style={{
                                backgroundColor: isActive ? isModalTab? '#e9f1f9':"#ffffff" : '#f2f7fb',
                                borderRadius: '6px 6px 0 0',
                                fontSize: '15px',
                                zIndex:99999
                            }}
                            onClick={() => onTabChange(index)}
                        >
                            {elem?.name ? elem.name : getDefaultName(tabType, index)}
                        </button>
                    );
                })}

                {addNewTab && (
                    <button
                        type="button"
                        className="btn btn-link ms-2"
                        onClick={addNewTab}
                        style={{
                            color: '#007bff',
                            fontWeight: 500,
                            fontSize: '14px',
                            textDecoration: 'none',
                        }}
                    >
                        + Add Plaintiff
                    </button>
                )}
            </div>
        </>
    )
}

export default Tabs;